function quickAddToCartSubmit(event, form) {

  let submitBtn = event.target.querySelector(".submit-btn");
  let sendUrl = "/cart/add.js";
  let addedText = submitBtn.dataset.addedtext;  
  let formData = new FormData(form);
  let params = new URLSearchParams(formData);
  let options = {
    method: 'POST',
    body: params
  };

  fetch(sendUrl, options)
    .then(function (response) {
      if (response.ok) {
        submitBtn.innerText = addedText;
        submitBtn.setAttribute("disabled", "disabled");
        return response.json();
      }
      return Promise.reject(response);
  }).then(function (data) {
      // console.log(data);
  }).catch(function (error) {
      // console.warn(error);
  });      
}


document.addEventListener('DOMContentLoaded', () => {

  let addToCartForm = document.querySelectorAll(".add-to-cart-custom");

  addToCartForm.forEach( (form) => {
    form.addEventListener("submit", (e) => {
      e.preventDefault();
      quickAddToCartSubmit(e, form);
    });
  });
  
});